export { GestionAlmacen } from "./pages/GestionAlmacen";

export { HistoricoInventarios } from "./pages/HistoricoInventarios";

export { AlmacenesInventario } from "./pages/AlmacenesInventario";

export { InventarioInicial } from "./pages/InventarioInicial";

export { ReporteInventarios } from "./pages/ReporteInventarios";

export { CreacionCierreMensual } from "./pages/CierresMensualesInventario/CreacionCierreMensual";

export { DetalleCierreMensual } from "./pages/CierresMensualesInventario/DetalleCierreMensual";

export { IngresosAlmacen } from "./pages/IngresosAlmacen";

export {
    InventarioOtrosAcopios,
    SobranteAlmacenConsulta,
} from "./pages/InventarioOtrosAcopios";

